import cn from 'classnames'

import styles from './styles.module.scss'
import { ButtonProps } from './types'

export const Button = ({
  children,
  variant,
  className,
  onClick,
  ...props
}: ButtonProps) => {
  const classNames = cn(
    styles.button,
    {
      [styles.primary]: variant === 'primary',
      [styles.secondary]: variant === 'secondary' || !variant,
    },
    className
  )

  return (
    <button className={classNames} onClick={onClick} {...props}>
      {children}
    </button>
  )
}
